const React = require('react');
const _ = require('lodash');
const k = require('@gral/constants');
const act = require('@flux/actions/actView');
const moment = require('moment');

class Needs extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};

    this._myNeeds = [];
    this._requested = [];
  }

  // Needs have:
  // - Resource url [mandatory]
  // - datapath [mandatory]
  // - Other properties that can be retrieved in API from meta object
  // - refreshPeriod

  componentDidMount() {
    return this._myNeedsHandle();
  }
  componentDidUpdate() {
    return this._myNeedsHandle();
  }
  componentWillUnmount() {
    this._myNeeds = [];
    return (this._requested = []);
  }

  _myNeedsHandle() {
    const pending = [];
    for (const need of Array.from(this._myNeeds)) {
      const rsrc = this.props.data.get(need.dataPath);

      if (rsrc == null && _.indexOf(this._requested, need.dataPath) === -1) {
        pending.push(need);
        this._requested.push(need.dataPath);
        continue;
      }

      if (rsrc != null) {
        if (
          !rsrc.get('state') === k.rsrcStates.SYNCING ||
          (rsrc.get('fStale') && rsrc.get('state') === k.rsrcStates.IDLE && rsrc.get('errors').size === 0) ||
          (need.refreshPeriod &&
            moment().subtract(need.refreshPeriod, 'seconds') > moment(rsrc.get('date')) &&
            rsrc.get('state') === k.rsrcStates.IDLE &&
            rsrc.get('errors').size === 0)
        ) {
          pending.push(need);
          continue;
        }
      }
    }

    if (pending.length) {
      return act.fetchMultiple(pending);
    }
  }

  iNeed(need) {
    // # {url, dataPath, retryPeriod, refreshPeriod} = need
    if (_.find(this._myNeeds, o => o.dataPath === need.dataPath)) {
      return;
    }
    return this._myNeeds.push(need);
  }

  iDontNeed(need) {
    const myNeedIndex = _.findIndex(this._myNeeds, o => o.dataPath === need.dataPath);
    if (myNeedIndex > -1) {
      this._myNeeds.splice(myNeedIndex, 1);
    }
    const myRequestedIndex = _.indexOf(this._requested, need.dataPath);
    if (myRequestedIndex > -1) {
      this._requested.splice(myNeedIndex, 1);
    }
    return act.markAsStale(need.dataPath);
  }
}

module.exports = Needs;
